import liveService from '../services/liveServiceV2'
import i18n from '@/translations/lang'
import { mapState, mapMutations } from 'vuex'
import videosApi from '@/services/videosApi'
import { THUMB_URL } from '@/config/envs'
import Storage from '@/utils/Storage'
import { subMinutes } from 'date-fns'
import { addMinutes } from 'date-fns/esm'
import liveChat from '@/services/liveChat'
//import axios from 'axios'
import LiveGraph from '@/components/LiveGraph.vue'

export default {
  components: { LiveGraph },
  data: () => ({
    liveInfo: {},
    showGraph: false,
    streamDetails: {},
    isBeta: false,
    viewMetrics: {},
    title: '',
    streamKey: '',
    hostId: '',
    streamUrl: '',
    defaultThumbnail: null,
    serverStatus: 'offline',
    livePlayer: '',
    restreamDialog: false,
    showCDN: false,
    imageError: false,
    liveEnded: false,
    loading: false,
    scheduled: null,
    liveStatus: '',
    showLiveTitle: false,
    reStreamError: null,
    saveLoading: false,
    cancelLoading: false,
    addRestreamLoading: false,
    reStreamLoading: false,
    streamHls: '',
    successfulChangedThumb: false,
    latency_type: '',
    current_time: '',
    created_at: '',
    bitrate: '',
    folderId: '',
    activeDvr: false,
    errors: {
      addThumbnail: false,
      wrongThumbnailFile: false,
      liveFetch: false,
      updateTitleError: false,
      initNow: null,
      viewers: false,
      liveEnd: false,
    },
    loadings: {
      newThumbnail: false,
      initNow: false,
      endLive: false,
    },
    newRestream: {
      rtmp: '',
      streamKey: '',
    },
    newThumbnail: {
      file: null,
    },
    restreams: [],
    checkViewers: null,
    viewers: 0,
    scheduled_at: '',
    lastVerificationServer: '',
    dDisplay: '',
    value: '',
    attrs: '',
    on: '',
    liveBytesIn: 0,
    previousBytes: null,
    previousTime: null,
    liveKbps: null,
  }),
  async mounted() {
    this.isBeta = location.search.match('beta')
    clearInterval(this.checkViewers)
  },
  beforeDestroy() {
    clearInterval(this.checkViewers)
    clearTimeout(this.infoHostTimeout)
    clearInterval(this.checkViewers)
    clearTimeout(this.verifyTimeout)
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
    showScheduled() {
      return this.scheduled && subMinutes(this.scheduled, 6) > new Date()
    },
    isServerClosed() {
      if (this.scheduled) {
        return (
          addMinutes(this.scheduled, 5) < new Date() &&
          this.serverStatus === 'offline'
        )
      }
      return this.serverStatus === 'offline'
    },
    liveTransmissionStatus() {
      const targetRate = 2500 // 2.5 Mbps best scenario
      const errorMargin = 200 // worst scenario

      if (
        this.liveKbps === null ||
        this.previousBytes === null ||
        this.previousTime === null
      )
        return null

      if (this.liveKbps >= targetRate - errorMargin) return 'good'

      if (this.liveKbps >= targetRate - 2 * errorMargin) return 'unstable'

      return 'bad'
    },
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    async fetchData() {
      if (!this.$route.params.id) return
      this.loading = true
      try {
        const response = await liveService.getLive(this.$route.params.id)
        this.errors.liveFetch = false
        this.liveInfo = response.data
        this.$root.liveStatus = response.data.status
        this.oldVideo.title = response.data.title
        this.bitrate = response.data.bitrate
        this.video.title = response.data.title
        this.oldTitle = response.data.title
        this.created_at = response.data.created_at
        this.streamKey = response.data.stream_key
        this.latency_type = response.data.latency_type
        this.current_time = response.data.current_time
        this.folderId = response.data.folder_id
        this.activeDvr = response.data.active_dvr
        this.hostId = response.data.host_id
        this.streamUrl = response.data.rtmp
        this.streamHls = response.data.live_hls
        this.livePlayer = response.data.live_player
        this.viewMetrics = response.data.view_metrics
        this.videoId = response.data.video_id
        this.serverStatus = response.data.host_status
        this.liveStatus = response.data.status

        if (
          this.liveStatus === 'online' &&
          this.serverStatus === 'online' &&
          !this.timeCounter
        ) {
          !this.isTimingDown ? this.setCounter() : ''
        }

        if (Object.keys(this.viewMetrics).length > 0) this.showGraph = true

        if (response.data.thumbnail) {
          this.defaultThumbnail = response.data.thumbnail
        }
        if (response.data.scheduled_at)
          this.scheduled = new Date(response.data.scheduled_at)
        this.scheduled_at = response.data.scheduled_at
        if (this.liveStatus === 'online') {
          this.liveCheckViewers()
        }

        if (this.timeLeft() <= 30) {
          await this.verifyServer()
          if (this.timeLeft() > 0) {
            if (this.timeLeft() > 5) {
              this.setTimeDown(
                new Date(this.scheduled_at).getTime() -
                  new Date().getTime() -
                  25 * 60 * 1000
              )
            } else {
              this.setTimeDown(
                new Date(this.scheduled_at).getTime() - new Date().getTime()
              )
            }
          } else {
            this.setTimeDown(
              addMinutes(new Date(this.scheduled_at), 5).getTime() -
                new Date().getTime()
            )
          }
        } else {
          setTimeout(this.fetchData, (this.timeLeft() - 30) * 60 * 1000)
        }
      } catch (error) {
        this.errors.videoDoesNotExist = true
        this.errors.liveFetch = true
      }
      this.loading = false
    },
    async verifyServer() {
      if (!this.$route.params.id) return
      if (this.$route.name === 'NewLiveV2') {
        try {
          this.lastVerificationServer = this.serverStatus
          const response = await liveService.getLive(this.$route.params.id)
          this.liveInfo = response.data
          this.liveStatus = response.data.status
          this.$root.liveStatus = response.data.status
          this.serverStatus = response.data.host_status

          const live_cache = Storage.getItem('lives')
          if (live_cache) {
            const current_live_cache_index = live_cache.findIndex(
              (l) => l.id == this.$route.params.id
            )

            if (current_live_cache_index != -1) {
              live_cache[current_live_cache_index] = {
                ...live_cache[current_live_cache_index],
                status: this.liveStatus,
              }
              Storage.setItem('lives', live_cache)
            }
          }
          if (
            this.liveStatus === 'online' &&
            this.serverStatus === 'online' &&
            !this.timeCounter
          ) {
            !this.isTimingDown ? this.setCounter() : ''
          }

          if (!this.videoId) {
            this.videoId = response.data.video_id

            if (this.videoId) {
              this.readVideoInfo()
            }
          }

          if (this.liveStatus === 'online') {
            this.liveCheckViewers()
          }
          if (this.isStreamingRightNow === true || this.isPlayerLive === true) {
            this.verifyTimeout = setTimeout(this.verifyServer, 10000)
          }
        } catch (error) {
          this.errors.liveFetch = true
        }
      }
    },
    async handleEndLive() {
      this.loadings.endLive = true
      try {
        await liveService.endLive(this.$route.params.id)
        this.errors.liveEnd = false
        this.liveStatus = 'finished'
        this.$root.liveStatus = 'finished'
        this.$root.$emit('statusChanged', 'finished')
        this.liveEnded = true
        await liveChat.terminateChat(this.$route.params.id)
      } catch (error) {
        this.errors.liveEnd = true
      }
      this.loadings.endLive = false
    },
    clearErrors() {
      Object.keys(this.errors).forEach((e) => (this.errors[e] = false))
    },
    async fethViewers() {
      if (this.liveStatus !== 'online') {
        clearInterval(this.checkViewers)
      } else {
        try {
          const response = await liveService.getViewers(this.$route.params.id)
          this.viewers = response.data.viewers
          this.errors.viewers = false
        } catch (e) {
          this.errors.viewers = true
        }
      }
    },
    handleShowLink(item) {
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.copiedToClipboard'),
      })
      navigator.clipboard.writeText(`${item}`)
    },
    handleDisplayKey() {
      this.value = !this.value
    },
    async handleAddRestream() {
      this.addRestreamLoading = true
      await liveService.addRestream(
        this.$route.params.id,
        this.newRestream.rtmp,
        this.newRestream.streamKey
      )
      this.addRestreamLoading = false
      this.newRestream.rtmp = ''
      this.newRestream.streamKey = ''
      this.restreams.push({
        rtmp_id: 'DRAFT',
        rtmp_url: `${this.newRestream.rtmp}/${this.newRestream.streamKey}`,
      })
      await this.fetchRestreams()
    },
    async handleChangeThumbnail() {
      this.successfulChangedThumb = false
      this.clearErrors()
      const file = this.newThumbnail.file
      let fileExtension =
        file?.name?.substring(
          file?.name?.lastIndexOf('.') + 1,
          file?.name?.length
        ) || file?.name
      if (
        fileExtension !== 'jpg' &&
        fileExtension !== 'png' &&
        fileExtension !== 'jpeg'
      ) {
        this.errors.wrongThumbnailFile = true
        this.newThumbnail.file = null
        return
      }
      this.loadings.newThumbnail = true
      const data = new FormData()
      data.append('file', file)
      let str = this.livePlayer
      let LIBRARY_ID = str
        .split('//')
        .pop()
        .split('.')[0]
        .replace('player-', '')
      const date = new Date().getTime()
      try {
        const ret = await videosApi.addThumbnailToVideo(
          this.$route.params.id + '?type=live',
          data
        )
        this.imageError = false
        this.loadings.newThumbnail = false
        this.defaultThumbnail = `${THUMB_URL}/${LIBRARY_ID}/${ret.data.response.thumbnail}?date=${date}`
        this.successfulChangedThumb = true
        return ret
      } catch (e) {
        this.loadings.newThumbnail = false
        this.errors.addThumbnail = true
      }
      this.loadings.newThumbnail = false
    },
    timeLeft() {
      let startDate = new Date()
      let endDate = new Date(this.scheduled_at)
      let minutes = Math.round(
        (endDate.getTime() - startDate.getTime()) / 1000 / 60
      )
      return minutes
    },
    closeModal() {
      this.restreamDialog = false
      setTimeout(() => {
        this.reStreamError = null
      }, 200)
    },
    async openRestreamModal() {
      this.reStreamLoading = true
      this.restreamDialog = true
      this.reStreamError = null
      await this.fetchRestreams()
      this.reStreamLoading = false
    },
    calculateKbps({ bytes_in, time }) {
      let kbps = null

      if (this.previousTime === null) {
        this.previousBytes = bytes_in
        this.previousTime = time
      } else {
        const deltaBytes = bytes_in - this.previousBytes
        const deltaTime = (time - this.previousTime) / 1000 // Convert to seconds
        const deltaBits = deltaBytes * 8

        kbps = parseInt(deltaBits / deltaTime / 1000, 10)
      }

      this.previousBytes = bytes_in
      this.previousTime = time

      this.liveKbps = kbps
    },

    async handleCancelLive() {
      this.$root.$emit('deleteVideoModal', [this.$route.params.id], 'Live')
    },
    handleUndoChanges() {
      this.video.title = this.oldTitle
    },
    async handleInitNow() {
      this.loadings.initNow = true
      try {
        await liveService.initLive(this.$route.params.id)
        this.scheduled = addMinutes(new Date(), 5)
        this.errors.initNow = null
      } catch (error) {
        this.errors.initNow = error.response.data.message
      }
      this.loadings.initNow = true
      this.fetchData()
    },
    async fetchRestreams() {
      try {
        const ret = await liveService.getRestreams(this.$route.params.id)
        this.restreams = ret.data
      } catch (error) {
        if (error.response.status === 400) {
          this.reStreamError = 'Live offline'
        }
      }
    },
    async deleteRestream(restream_id) {
      this.restreams = this.restreams.filter(
        (item) => item.rtmp_id !== restream_id
      )
      await liveService.deleteRestreams(restream_id, this.$route.params.id)
    },
    async handleSaveName() {
      this.activeInput = ''
      if (this.oldVideo.title !== this.video.title) {
        this.saveLoading = true
        try {
          await liveService.updateLiveTitle(
            this.$route.params.id,
            this.video.title
          )
          const live_cache = Storage.getItem('lives')
          if (live_cache) {
            const current_live_cache_index = live_cache.findIndex(
              (l) => l.id == this.$route.params.id
            )

            if (current_live_cache_index != -1) {
              live_cache[current_live_cache_index] = {
                ...live_cache[current_live_cache_index],
                title: this.video.title,
              }
              Storage.setItem('lives', live_cache)
            }
          }
          this.errors.updateTitleError = false
        } catch (error) {
          this.errors.updateTitleError = true
        }
        this.oldVideo.title = this.video.title
        this.saveLoading = false
        this.handleSnackbar()
      }
    },
    handleBackToListing() {
      if (window.history.length > 2) {
        this.$router.go(-1)
        return
      }
      this.$router.push({ name: 'LiveV2' })
    },
    liveCheckViewers() {
      if (this.liveStatus === 'online') {
        this.checkViewers && clearInterval(this.checkViewers)
        this.fethViewers()
        this.checkViewers = setInterval(() => {
          this.fethViewers()
        }, 10000)
      }
    },
    handleSnackbar() {
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.changesSaved'),
      })
    },
  },
}
